import type { TOC } from '@ember/component/template-only';
import LoanDetail from 'tio-employee/components/reimagined/loan-detail';
import type { LoanDetailModel } from 'tio-employee/components/reimagined/loan-detail';

interface Signature {
  Args: { model: LoanDetailModel };
}

const template: TOC<Signature> = <template>
  <LoanDetail @model={{@model}} @variant="production" />
</template>;

export default template;
